// employeePositions/state.js

export const employeePositionsInitialState = {
  list: [],
  loading: false,
  error: null,
};
